import React from "react";
import { Button } from "./ui/button";
import { 
  Smartphone, 
  Shirt, 
  Home, 
  ShoppingBag,
  Zap,
  ArrowRight
} from "lucide-react";
import { Link } from "react-router-dom";

const Categories = () => {
  const categories = [
    {
      icon: Smartphone,
      title: "Électronique",
      description: "Nous proposons une large gamme de produits électroniques de qualité : smartphones dernière génération, tablettes, ordinateurs portables, accessoires informatiques, équipements audio et vidéo. Tous nos produits électroniques sont soigneusement sélectionnés auprès de fabricants reconnus pour leur fiabilité et leur innovation technologique.",
      iconColor: "text-blue-600",
      iconBg: "bg-blue-100",
      buttonText: "Nous contacter pour l'électronique"
    },
    {
      icon: Home,
      title: "Électroménager",
      description: "Découvrez notre sélection d'appareils électroménagers pour simplifier votre quotidien : petit électroménager de cuisine, aspirateurs, machines à café, robots culinaires, et bien plus encore. Nous privilégions les marques reconnues pour leur durabilité et leur efficacité énergétique.",
      iconColor: "text-emerald-600",
      iconBg: "bg-emerald-100",
      buttonText: "Nous contacter pour l'électroménager"
    },
    {
      icon: Shirt,
      title: "Vêtements",
      description: "Notre collection textile couvre tous les besoins : mode homme, femme et enfant, vêtements de travail, tenues décontractées et habillées. Nous sélectionnons des tissus de qualité et des coupes modernes pour offrir confort et style à tous nos clients, quelle que soit la saison.",
      iconColor: "text-purple-600",
      iconBg: "bg-purple-100",
      buttonText: "Nous contacter pour les vêtements"
    },
    {
      icon: ShoppingBag,
      title: "Chaussures",
      description: "Explorez notre gamme complète de chaussures pour toute la famille : baskets tendance, chaussures de ville élégantes, chaussures de sport performantes, bottes et sandales. Nous mettons l'accent sur le confort, la qualité des matériaux et la durabilité pour satisfaire tous les styles et budgets.",
      iconColor: "text-orange-600",
      iconBg: "bg-orange-100",
      buttonText: "Nous contacter pour les chaussures"
    },
    {
      icon: Zap,
      title: "Première nécessité",
      description: "Retrouvez tous les produits essentiels du quotidien : articles d'hygiène personnelle, produits d'entretien ménager, accessoires de cuisine, fournitures de bureau et bien d'autres produits indispensables. Notre objectif est de vous faciliter l'approvisionnement en produits de première nécessité à des prix compétitifs.",
      iconColor: "text-teal-600",
      iconBg: "bg-teal-100",
      buttonText: "Nous contacter pour les produits essentiels"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
              Nos catégories de produits
            </h2>
            <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
              Découvrez notre large gamme de produits soigneusement sélectionnés 
              pour répondre à tous vos besoins quotidiens et professionnels.
            </p>
          </div>

          {/* Categories Sections */}
          <div className="space-y-24">
            {categories.map((category, index) => (
              <div key={index} className="flex flex-col items-center text-center max-w-4xl mx-auto">
                {/* Icon & Title */}
                <div className="mb-8">
                  <div className={`w-24 h-24 ${category.iconBg} rounded-2xl flex items-center justify-center mx-auto mb-6`}>
                    <category.icon className={`w-12 h-12 ${category.iconColor}`} />
                  </div>
                  <h3 className="text-2xl lg:text-3xl font-bold text-slate-900">
                    {category.title}
                  </h3>
                </div>
                
                {/* Content */}
                <div className="mb-8">
                  <p className="text-slate-600 leading-relaxed text-lg max-w-3xl mx-auto">
                    {category.description}
                  </p>
                </div>
                
                {/* Button */}
                <Link to="/contact">
                  <Button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 group">
                    {category.buttonText}
                    <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </Link>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center bg-white rounded-2xl p-8 lg:p-12 shadow-lg mt-32">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">
              Vous ne trouvez pas ce que vous cherchez ?
            </h3>
            <p className="text-slate-600 mb-6 max-w-2xl mx-auto">
              Contactez-nous ! Grâce à notre réseau international, nous pouvons 
              sourcer une grande variété de produits selon vos besoins spécifiques.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3">
                Nous contacter
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Categories;